import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Tokenomics from './components/Tokenomics';
import Analytics from './components/Analytics';
import Roadmap from './components/Roadmap';
import Community from './components/Community';
import Footer from './components/Footer';
import LeadCapture from './components/LeadCapture';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-pink-100">
        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <motion.main
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
              >
                <Hero />
                <Features />
                <Tokenomics />
                <Analytics />
                <Roadmap />
                <Community />
                <LeadCapture />
              </motion.main>
            }
          />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;